import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { MASKS } from 'ng-brazil';
import { PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { TipoArquivo } from 'src/app/models/enum';
import { ModeloDownloadAnexo } from 'src/app/models/modelo-download-anexo';
import { ArquivoService } from 'src/app/services/arquivo.service';
import { CarregandoService } from 'src/app/services/carregando.service';
import { EnumService } from 'src/app/services/enum.service';
import { GlobalService } from 'src/app/services/global.service';
import { ModeloDownloadAnexoService } from 'src/app/services/modelo-download-anexo.service';
import { NotificacaoService } from 'src/app/services/notificacao.service';
import { UtilitarioService } from 'src/app/services/utilitario.service';
import { ViaCepService } from 'src/app/services/via-cep.service';

@Component({
  selector: 'app-cadastrar-modelo-de-download',
  templateUrl: './cadastrar-modelo-de-download.component.html',
  styleUrls: ['./cadastrar-modelo-de-download.component.scss']
})
export class CadastrarModeloDeDownloadComponent implements OnInit {

  // variáveis
  idModeloDownload;
  idPedido;
  modeloDownloadAnexo = new ModeloDownloadAnexo();
  editando = false;
  carregando = true;
  public MASKS = MASKS;
  editavel = true;
  padrao = false;
  public config: PerfectScrollbarConfigInterface = {};
  selectedFile: File;
  nomeArquivoBanco = '';

  constructor(private route: ActivatedRoute, private notificacaoService: NotificacaoService,
    private modeloDownloadAnexoService: ModeloDownloadAnexoService, private enumService: EnumService,
    private router: Router, private viaCepService: ViaCepService, public dialog: MatDialog,
    private globalService: GlobalService, private carregandoService: CarregandoService,
    private utilitarioService: UtilitarioService, private arquivoService: ArquivoService) {
    // this.idModeloDownload = data.id;
  }

  ngOnInit() {

    // se for edição, busca o modeloDownloadAnexo do id passado
    if (this.idModeloDownload) {
      this.editando = true;
      this.buscarModeloDownload();
    } else {
      this.modeloDownloadAnexo = new ModeloDownloadAnexo();
      this.modeloDownloadAnexo.arquivo = '';
      this.atualizaDadosModeloDownload();
    }

    if (this.route.snapshot.paramMap.get('id')) {
      this.idModeloDownload = this.route.snapshot.paramMap.get('id');
      this.editando = true;
      this.buscarModeloDownload();
    } else {
      this.modeloDownloadAnexo = new ModeloDownloadAnexo();
      this.modeloDownloadAnexo.arquivo = '';
      this.atualizaDadosModeloDownload();
    }
  }

  ngAfterViewInit(): void {
    this.utilitarioService.rodaScriptTabEnter();
  }

  buscarModeloDownload() {

    this.carregandoService.mostra('buscaModeloDownload');

    this.modeloDownloadAnexoService.consultarPorIdModeloDownloadAnexo(this.idModeloDownload).subscribe(modelo => {
      this.modeloDownloadAnexo = modelo;
      this.nomeArquivoBanco = this.modeloDownloadAnexo.arquivo;
      this.atualizaDadosModeloDownload();
    }, (erro) => {
      this.carregandoService.esconde('buscaModeloDownload');
      this.notificacaoService.erro(erro);
    });
  }

  atualizaDadosModeloDownload() {

    this.carregando = false;

    this.carregandoService.esconde('buscaModeloDownload');
  }

  voltar(){
    this.router.navigate(['configuracoes/modelos-de-download']);
  }

  salvar() {
    this.carregandoService.mostra('salvaModeloDownload');

    const dados = new FormData();
    if (this.selectedFile) {
      dados.append('arquivo_consulta', this.selectedFile);
      dados.append('arqui[arquivo]', this.selectedFile.name);
    } else {
      dados.append('arqui[arquivo]', this.modeloDownloadAnexo.arquivo);
    }

    dados.append('arqui[id]', this.modeloDownloadAnexo.id ? this.modeloDownloadAnexo.id.toString() : '0');
    dados.append('arqui[descricao]', this.modeloDownloadAnexo.descricao);
    dados.append('arqui[idAnexo]', this.modeloDownloadAnexo.idAnexo ? this.modeloDownloadAnexo.idAnexo.toString() : '0');

    this.modeloDownloadAnexoService.salvar(dados).subscribe(() => {
      this.notificacaoService.sucesso('Modelo salvo com sucesso!!!');
      this.router.navigate(['configuracoes/modelos-de-download']).then(() => {
        this.carregandoService.esconde('salvaModeloDownload');
      });



    }, (erro) => {
      this.carregandoService.esconde('salvaModeloDownload');
      this.notificacaoService.erro(erro);
    });
  }

  ngOnDestroy(): void {

  }


  onFileChanged(event) {
    this.selectedFile = event.target.files[0];
  }

  baixarArquivo() {

    this.carregandoService.mostra('baixarArquivo');
    this.arquivoService.baixarArquivo(this.idModeloDownload, TipoArquivo.ModeloDownload).subscribe(arq => {
      this.utilitarioService.saveBlob(arq, this.nomeArquivoBanco);
      this.carregandoService.esconde('baixarArquivo');
    }, (erro) => {
      this.carregandoService.esconde('baixarArquivo');
      this.notificacaoService.erro(erro);
    });

  }

  excluirArquivo() {
    this.selectedFile = undefined;
    this.modeloDownloadAnexo.arquivo = '';
  }

}
